import React from 'react';

export default () => {
  return <span style={{ color: '#CDD5DF' }}>—</span>;
};
